export default "__VITE_ASSET__b0c3f433__"